import official1 from "../images/official1.jpeg";
import official2 from "../images/official2.jpeg";

const officialArray = () => {
  return [official1, official2];
};

export default officialArray();
